import React, { useContext } from 'react';

import DnDElement from './DnDElement';
import { ElementContext } from '../ElementRenderContext';
import ButtonAddNew from './other-components/ButtonAddNew';
import EmptyDropTarget from './other-components/EmptyDropTarget/EmptyDropTarget';

const getElType = (parentType) => {
    const elTypes = {
        page: 'SECTION',
        section: 'ROW',
        row: 'COLUMN',
        column: 'ELEMENT',
    };
    if (!elTypes.hasOwnProperty(parentType)) {
        throw new Error(`No element type found for '${parentType}'`);
    }
    return elTypes[parentType];
};

const getAddress = (parentAddress, index) => {
    return (parentAddress ? `${parentAddress}.` : '') + index;
};

const RecursiveRender = React.memo(function _RecursiveRender(props) {
    const { type, content, onDragItem, parentAddress } = props;
    const { showAddModal, onSaveSettings } = useContext(ElementContext);
    return (
        <>
            {content && content.length ? (
                content
                    .filter((v) => v)
                    .map((item, index) => (
                        <DnDElement
                            item={item}
                            key={item.id}
                            index={index}
                            type={item.type}
                            parentType={type}
                            onDragItem={onDragItem}
                            parentAddress={parentAddress}
                            onSaveSettings={onSaveSettings}
                            address={getAddress(parentAddress, index)}
                        >
                            {Array.isArray(item.content) ? (
                                <RecursiveRender
                                    type={item.type}
                                    content={item.content}
                                    onDragItem={onDragItem}
                                    parentAddress={getAddress(
                                        parentAddress,
                                        index
                                    )}
                                />
                            ) : (
                                item.content
                            )}
                        </DnDElement>
                    ))
            ) : (
                <EmptyDropTarget
                    type={type}
                    onDragItem={onDragItem}
                    parentAddress={parentAddress}
                >
                    <ButtonAddNew
                        onClick={() =>
                            showAddModal(
                                getElType(type),
                                `${getAddress(parentAddress, '-1')}`
                            )
                        }
                        type={type}
                    />
                </EmptyDropTarget>
            )}
        </>
    );
});

export default RecursiveRender;
